import React from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';
import Button from '../../../components/ui/Button';

const UpcomingBirthdaysCard = ({ upcomingBirthdays = [], onViewAll = () => {} }) => {
  const navigate = useNavigate();

  const getDaysUntilBirthday = (birthday) => {
    const today = new Date();
    const currentYear = today?.getFullYear();
    const birthdayThisYear = new Date(currentYear, birthday.getMonth(), birthday.getDate());
    
    if (birthdayThisYear < today) {
      birthdayThisYear?.setFullYear(currentYear + 1);
    }
    
    const diffTime = birthdayThisYear - today;
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    return diffDays;
  };

  const handleContactClick = (contact) => {
    navigate('/contact-details', { state: { contact } });
  };

  const handleSendWishes = (contact, e) => {
    e?.stopPropagation();
    navigate('/message-templates', { state: { selectedContact: contact, type: 'birthday' } });
  };

  return (
    <div className="bg-surface rounded-lg border border-border shadow-card p-4 lg:p-6">
      <div className="flex items-center justify-between mb-4">
        <div className="flex items-center space-x-2">
          <Icon name="Calendar" size={20} className="text-primary" />
          <h2 className="text-lg font-semibold text-text-primary">Upcoming Birthdays</h2>
        </div>
        <Button
          variant="ghost"
          size="sm"
          onClick={onViewAll}
          iconName="ArrowRight"
          iconPosition="right"
        >
          View All
        </Button>
      </div>
      {upcomingBirthdays?.length === 0 ? (
        <div className="text-center py-8">
          <Icon name="Calendar" size={48} className="mx-auto mb-3 text-text-secondary opacity-50" />
          <p className="text-text-secondary">No upcoming birthdays</p>
          <Button
            variant="outline"
            size="sm"
            className="mt-3"
            onClick={() => navigate('/contact-list')}
            iconName="Plus"
            iconPosition="left"
          >
            Add Contacts
          </Button>
        </div>
      ) : (
        <div className="space-y-3">
          {upcomingBirthdays?.slice(0, 5)?.map((contact) => {
            const daysUntil = getDaysUntilBirthday(new Date(contact.birthday));
            const isToday = daysUntil === 0;
            const isTomorrow = daysUntil === 1;

            return (
              <div
                key={contact?.id}
                onClick={() => handleContactClick(contact)}
                className={`flex items-center space-x-3 p-3 rounded-lg border transition-micro hover-lift cursor-pointer ${
                  isToday 
                    ? 'bg-primary/10 border-primary' :'bg-background border-border hover:bg-muted'
                }`}
              >
                <div className="relative">
                  <div className="w-12 h-12 rounded-full overflow-hidden bg-muted flex-shrink-0">
                    {contact?.avatar ? (
                      <Image
                        src={contact?.avatar}
                        alt={contact?.name}
                        className="w-full h-full object-cover"
                      />
                    ) : (
                      <div className="w-full h-full flex items-center justify-center bg-primary/20">
                        <Icon name="User" size={20} className="text-primary" />
                      </div>
                    )}
                  </div>
                  {isToday && (
                    <div className="absolute -top-1 -right-1 w-6 h-6 bg-primary rounded-full flex items-center justify-center">
                      <Icon name="Gift" size={12} color="white" />
                    </div>
                  )}
                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center space-x-2">
                    <h3 className="font-medium text-text-primary truncate">
                      {contact?.name}
                    </h3>
                    {isToday && (
                      <span className="text-xs bg-primary text-primary-foreground px-2 py-1 rounded-full">
                        Today!
                      </span>
                    )}
                  </div>
                  <p className="text-sm text-text-secondary">
                    {isToday 
                      ? 'Birthday today' 
                      : isTomorrow 
                        ? 'Tomorrow' 
                        : `${daysUntil} days`
                    }
                  </p>
                </div>
                <div className="flex items-center space-x-2">
                  {(isToday || isTomorrow) && (
                    <Button
                      variant="default"
                      size="sm"
                      onClick={(e) => handleSendWishes(contact, e)}
                      iconName="Send"
                      iconPosition="left"
                    >
                      Send Wishes
                    </Button>
                  )}
                  <Icon name="ChevronRight" size={16} className="text-text-secondary" />
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default UpcomingBirthdaysCard;